var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar',{staticClass:"footer"},[(_vm.recordId)?_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.deleteRecord}},[_vm._v("削除")]):_vm._e(),_c('v-spacer'),(_vm.displaySave)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.save}},[_vm._v("保存")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }